import React, { forwardRef } from 'react';

import { cssMap } from '@atlaskit/css';
import type { PopupComponentProps } from '@atlaskit/popup/types';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	popup: {
		zIndex: 1,
		backgroundColor: token('color.background.neutral.subtle'),
	},
});

const PopupComponent: React.ForwardRefExoticComponent<
	Omit<PopupComponentProps, 'ref'> & React.RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, PopupComponentProps>(({ 'data-testid': testId, ...props }, ref) => (
	<Box {...props} ref={ref} xcss={styles.popup} testId={testId} />
));

export default PopupComponent;
